import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

import {
  updateJobs,
  getDevice
} from "../utils/index";
import qs from 'qs';

Vue.use(Vuex);

export default () =>
  new Vuex.Store({
    state: {
      device: null,
      jobs: null,
      idCategoryActive: 0,
      idJobActive: 0,
      idJobInfo: 0,
      showModal: false,
      modalType: '', // job, saisie, max, email, merci
      footerIsOpen: false,
      appIsFreeze: false,
      email: ''
    },
    getters: {
        jobsInCategory: state => idCategory => {
            var jobs = [];
            for (var idx in state.jobs) {
                var job = state.jobs[idx];
                if (job.categoryId === idCategory) {
                    jobs.push(job);
                }
            }
            return jobs
        },
        total: state => {
          var total = 0;
          for (var id in state.jobs) {
            var job = state.jobs[id];
            if (job.nbjours !== 0) {
                total += job.nbjours * job.tjm_ht
            }
          }
          return total;
        },
        idJobActive: state => {
            return state.idJobActive
        },
        jobActive: state => {
            return state.idJobActive !== 0 ? state.jobs[state.idJobActive] : null
        },
        idJobInfo: state => {
            return state.idJobInfo
        },
        jobInfo: state => {
            return state.idJobInfo !== 0 ? state.jobs[state.idJobInfo] : null
        },
        jobNb: state => idJob => state.jobs[idJob].nbjours,
        showModal: state => state.showModal,
        modalType: state => state.modalType,
        footerIsOpen: state => state.footerIsOpen,
        appIsFreeze: state => state.appIsFreeze
    },
    mutations: {
      SET_JOBS(state, jobs) {
        state.jobs = updateJobs(jobs);
        state.idCategoryActive = 1;
      },
      SET_DEVICE(state, device) {
          state.device = device
      },
      UPDATE_NB(state, data) {
          state.jobs[data.jobid].nbjours = data.nbjours
          this.commit('UPDATE_TOTAL')
      },
      UPDATE_TOTAL(state) {
          var total = 0;
          for (var id in state.jobs) {
            var job = state.jobs[id];
            if (job.nbjours !== 0) {
                total += job.nbjours * job.tjm_ht
            }
          }
          total = Math.round(total*1.15);
          if (total > 99999) {
              total = 99999;
              state.showModal = true;
              state.modalType = 'max';
          }
          document.getElementById('js__total').innerHTML = total
          if (total > 0) {
              if (document.getElementById('cal__body_total_mobile')) {
                document.getElementById('cal__body_total_mobile').className = 'cal__body_total cal__body_total--visible'
              }
              document.getElementById('cal__app_container').className = 'cal__container cal__container--total-visible'
          }
      },
      UPDATE_CATEGORY_ACTIVE(state, data) {
          state.idCategoryActive = data.categoryid
      },
      UPDATE_JOB_ACTIVE(state, data) {
          state.idJobActive = data.jobid
      },
      UPDATE_JOB_INFO(state, data) {
          state.idJobInfo = data.jobid
          if (state.device === 'mobile') {
              this.commit('SHOW_MODAL', { type: 'job' });
          }
      },
      SHOW_MODAL(state, data) {
          state.showModal = true
          state.modalType = data.type
      },
      SET_MODAL_TYPE(state, data) {
          state.modalType = data.type
      },
      CLOSE_MODAL(state) {
          state.showModal = false
      },
      UPDATE_FOOTER_POSITION(state) {
          state.footerIsOpen = !state.footerIsOpen
      },
      FREEZE_APP(state) {
          state.appIsFreeze = true;
      },
      UNFREEZE_APP(state) {
          state.appIsFreeze = false;
      },
      UPDATE_EMAIL(state, data) {
          state.email = data.email
      }
    },
    actions: {
        fetchData({commit}) {
          axios
            .get('https://www.eficiens.com/pricing_eficiens/json/tjm.json')
//            .get('https://prep.eficiens.com/pricing_eficiens/json/tjm.json')
//            .get('./fixtures/data.json')
            .then(response => {
                commit('SET_JOBS', response.data);
            });
        },
        getDevice({commit}){
            commit('SET_DEVICE', getDevice())
        },
        sendData({state, getters}) {
            // clean
            var conseil = getters.jobsInCategory(1).map(job => job.id + ':' + job.nbjours).join('|')
            var creation = getters.jobsInCategory(2).map(job => job.id + ':' + job.nbjours).join('|')
            var dev = getters.jobsInCategory(3).map(job => job.id + ':' + job.nbjours).join('|')
            
            // send POST script  
                //  $conseil = "id:nbjours|id:nbjours"  $creation = "id:nbjours|id:nbjours"  $dev = "id:nbjours|id:nbjours"
                // retour OK + lien excel
            const options = {
                method: 'POST',
                headers: { 'content-type': 'application/x-www-form-urlencoded' },
                data: qs.stringify({ conseil, creation, dev }),
//                url: 'test',
//                url: 'https://prep.eficiens.com/pricing_eficiens/scripts/generate_excel.php',
                url: 'https://www.eficiens.com/pricing_eficiens/scripts/generate_excel.php',
            };
            axios(options)
              .then(function ({ data }) {
                if (data.error.code === 0) {
                  const url_fichier = data.url_fichier
                  const email = state.email;
//                    // send GET Zapier (email + lien) https://legacydocs.hubspot.com/docs/methods/forms/submit_form
                    axios.get('https://hooks.zapier.com/hooks/catch/2293056/ogxgth2/', {
                      params: { email, url_fichier }
                    })
                    .then(function (response) {
                      console.log(response);
                    })
                    .catch(function (error) {
                      console.log(error);
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
            
            
            
            
        }
    },
    modules: {}
  });

